.markerContainer {
  cursor: pointer;
}
